// Web replacement for native-base Tabs. The original pages its scenes inside
// a horizontal ScrollView, which does not lay out correctly in the DOM.
// Here only the active scene is shown, the tab bar is the stock one.
import React from "react";
import { Animated, Dimensions, View } from "react-native-web";
import get from "lodash/get";
import { DefaultTabBar } from "native-base/dist/src/basic/Tabs/DefaultTabBar";
import { ScrollableTabBar } from "native-base/dist/src/basic/Tabs/ScrollableTabBar";

export default class Tabs extends React.Component {
  static DefaultTabBar = DefaultTabBar;
  static ScrollableTabBar = ScrollableTabBar;

  static defaultProps = {
    tabBarPosition: "top",
    initialPage: 0,
    page: -1,
    onChangeTab: () => {},
    onScroll: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: props.initialPage,
      visited: { [props.initialPage]: true },
      scrollValue: new Animated.Value(props.initialPage),
      containerWidth: Dimensions.get("window").width,
    };
    this.goToPage = this.goToPage.bind(this);
    this.onLayout = this.onLayout.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { page } = this.props;
    if (page >= 0 && page !== prevProps.page && page !== this.state.currentPage) {
      this.goToPage(page);
    }
  }

  scenes() {
    return React.Children.toArray(this.props.children);
  }

  goToPage(page) {
    const from = this.state.currentPage;
    this.state.scrollValue.setValue(page);
    this.setState(
      state => ({
        currentPage: page,
        visited: Object.assign({}, state.visited, { [page]: true }),
      }),
      () => {
        this.props.onScroll(page);
        this.props.onChangeTab({ i: page, ref: this.scenes()[page], from });
      },
    );
  }

  onLayout(e) {
    const { width } = e.nativeEvent.layout;
    if (width && Math.round(width) !== Math.round(this.state.containerWidth)) {
      this.setState({ containerWidth: width });
    }
  }

  renderTabBar(props) {
    if (this.props.renderTabBar === false) {
      return null;
    }
    if (this.props.renderTabBar) {
      return React.cloneElement(this.props.renderTabBar(props), props);
    }
    return <DefaultTabBar {...props} />;
  }

  render() {
    const scenes = this.scenes();
    const { tabBarPosition } = this.props;
    const overlay =
      tabBarPosition === "overlayTop" || tabBarPosition === "overlayBottom";
    const top = tabBarPosition === "top" || tabBarPosition === "overlayTop";

    const tabBarProps = {
      goToPage: this.goToPage,
      tabs: scenes.map(child => child.props.heading),
      tabStyle: scenes.map(child => child.props.tabStyle),
      activeTabStyle: scenes.map(child => child.props.activeTabStyle),
      textStyle: scenes.map(child => child.props.textStyle),
      activeTextStyle: scenes.map(child => child.props.activeTextStyle),
      tabHeaderStyle: scenes.map(child =>
        get(child.props.heading, "props.style", undefined),
      ),
      activeTab: this.state.currentPage,
      scrollValue: this.state.scrollValue,
      containerWidth: this.state.containerWidth,
    };
    [
      ["tabBarBackgroundColor", "backgroundColor"],
      ["tabBarActiveTextColor", "activeTextColor"],
      ["tabBarInactiveTextColor", "inactiveTextColor"],
      ["tabBarTextStyle", "textStyle"],
      ["tabBarUnderlineStyle", "underlineStyle"],
      ["tabContainerStyle", "tabContainerStyle"],
    ].forEach(([from, to]) => {
      if (this.props[from]) {
        tabBarProps[to] = this.props[from];
      }
    });
    if (overlay) {
      tabBarProps.style = {
        position: "absolute",
        left: 0,
        right: 0,
        [top ? "top" : "bottom"]: 0,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
      };
    }

    return (
      <View style={[{ flex: 1 }, this.props.style]} onLayout={this.onLayout}>
        {top ? this.renderTabBar(tabBarProps) : null}
        <View style={{ flex: 1 }}>
          {scenes.map((child, index) => {
            if (!this.state.visited[index]) {
              return null;
            }
            const active = index === this.state.currentPage;
            return (
              <View
                key={child.key || index}
                style={{ flex: 1, display: active ? "flex" : "none" }}
              >
                {child}
              </View>
            );
          })}
        </View>
        {!top ? this.renderTabBar(tabBarProps) : null}
      </View>
    );
  }
}
